import { CachedDropdownsGetters } from './partials/cached-dropdowns'
import { RouteSharedGetters } from './partials/route'
import { SharedSettingsGetters } from './partials/settings'
import { TmetricSharedGetters } from './partials/tmetric'
import { WorkflowSharedGetters } from './partials/workflow'

export const SharedGetters = {
  ...CachedDropdownsGetters,
  ...RouteSharedGetters,
  ...SharedSettingsGetters,
  ...TmetricSharedGetters,
  ...WorkflowSharedGetters,
}
